export const Loyalty = {
    receivedLoyaltyPointsMessage: 'received_loyalty_points',
    receiveLoyaltyPointsMessage: 'receive_loyalty_points'
};
